export default __webpack_public_path__ + "static/moocfi-logo-bw-40fb2db8a1b68fff676338919b31ae7c.png";